import ChatPanel from '#/features/ai-chat/chat-panel';
import Panel from './panel';

function UtilityPanel() {
  return (
    <Panel direction='right'>
      <ChatPanel />
    </Panel>
  );
}

export default UtilityPanel;
